/* Copyright (c) 2024 Xperi. All Rights Reserved. */

// eslint-disable-next-line no-shadow
export enum PickerStripType {
    NONE,
    HEADER_STRIP,
    PICKER_STRIP,
}
